import { useMemo } from 'react';
import { parseAction, resolveAction } from 'retil-history';
import { useRouterRequest } from './useRouterRequest';
export var useResolveRoute = function (action, state) {
    var pathname = useRouterRequest().pathname;
    var resolved = useMemo(function () { return resolveAction(parseAction(action, state), pathname); }, [action, pathname, state]);
    // Memoize by action parts so that we'll output the same location object
    // until something actually changes.
    var deps = [
        resolved === null || resolved === void 0 ? void 0 : resolved.pathname,
        resolved === null || resolved === void 0 ? void 0 : resolved.search,
        resolved === null || resolved === void 0 ? void 0 : resolved.hash,
        resolved === null || resolved === void 0 ? void 0 : resolved.state,
    ];
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return useMemo(function () { return resolved; }, deps);
};
